// fr strings for messages/studio.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const studio: Dict = {
  "studio.title.none": "Fais une cover",
  "studio.title.one": "Fais chanter {name}",
  "studio.title.many": "Fais-les chanter",
  "studio.section.voice": "Voix",
  "studio.section.whoSings": "Qui chante",
  "studio.section.count": "{n} sur {max}",
  "studio.section.audio": "Audio",
  "studio.pickVoice": "Choisis une voix",
  "studio.pickVoiceNote": "Plus de 100 000 voix, ou la tienne",
  "studio.addVoice": "Ajouter une voix",
  "studio.whoSingsWhen": "Qui chante quand",
  "studio.sound": "Son",
  "studio.video": "Vidéo",
  "studio.video.off": "Fais s'affronter tes voix dans une Marble Run",
  "studio.video.on": "Marble Run · 1 pièce",
  "studio.video.add": "Ajouter une Marble Run · 1 pièce",
  "studio.coins.unlimited": "Pièces illimitées avec Power",
  "studio.coins.one": "Il te reste {count} pièce",
  "studio.coins.other": "Il te reste {count} pièces",
  "studio.done": "OK",
  "studio.remove": "Retirer",
  "studio.cta.pickVoice": "Choisis d'abord une voix",
  "studio.cta.addAudio": "Ajoute un audio",
  "studio.cta.create": "Créer la cover",
  "studio.auth.video": "Inscris-toi pour faire une vidéo",
  "studio.auth.audio": "Inscris-toi pour utiliser ton audio",
  "studio.auth.save": "Enregistre ta cover",
  "studio.upgrade.marbleRun":
    "Passe à Creator pour faire des vidéos Marble Run",
  "studio.creatorReady": "Tu as Creator. Choisis ta Marble Run.",
  "studio.maxVoices": "Tu peux choisir {max} voix maximum.",
  "studio.alreadyIn": "{name} est déjà dans cette cover.",

  "studio.voices.search": "Rechercher des voix",
  "studio.voices.clear": "Effacer la recherche",
  "studio.voices.trending": "Tendances",
  "studio.voices.recent": "Utilisées récemment",
  "studio.voices.mine": "Mes voix",
  "studio.voices.music": "Musique",
  "studio.voices.cartoon": "Dessins animés",
  "studio.voices.gaming": "Jeux vidéo",
  "studio.voices.anime": "Anime",
  "studio.voices.publicFigure": "Personnalités",
  "studio.voices.oftenWith": "Souvent avec {name}",
  "studio.voices.pairedWith": "Souvent associée à {name}",
  "studio.voices.add": "Ajouter {name}",
  "studio.voices.change": "Changer {name}",
  "studio.voices.removeName": "Retirer {name}",
  "studio.voices.upTo": "Jusqu'à {max}",
  "studio.voices.makeDuet": "Fais-en un duo",
  "studio.voices.uses": "{n} utilisations",
  "studio.voices.noMatch": "Aucune voix ne correspond à ta recherche.",
  "studio.voices.noMine": "Tu n'as pas encore de voix entraînée.",
  "studio.voices.noPairs":
    "Pas encore de duo avec cette voix cette semaine. Essaie Tendances.",
  "studio.empty": "Rien ici pour l'instant.",
  "studio.change": "Changer",

  "studio.who.auto": "Auto",
  "studio.who.manual": "Je choisis",
  "studio.who.chose.one": "Ton choix · {n} partie",
  "studio.who.chose.other": "Ton choix · {n} parties",
  "studio.who.autoExplain":
    "Les voix se relaient à chaque changement de chanteur.",
  "studio.who.autoCanChoose":
    "Tu veux décider ? Avec Je choisis, tu choisis qui chante chaque partie.",
  "studio.who.autoNeedsFile":
    "Pour choisir toi-même, il faut un audio importé, un enregistrement ou un titre de la bibliothèque.",
  "studio.who.loading": "Chargement du titre…",
  "studio.who.failed":
    "Impossible de lire ce titre ici, Jammable va donc décider.",
  "studio.who.pause": "Pause",
  "studio.who.playSong": "Écouter le titre",
  "studio.who.partLabel": "{name}, de {start} à {end}",
  "studio.who.moveSwap": "Déplacer le changement de voix",
  "studio.who.part": "Partie {n}",
  "studio.who.play": "Lecture",
  "studio.who.split": "Couper",
  "studio.who.takeOver": "Qui reprend cette partie ?",
  "studio.who.before": "La partie d'avant",
  "studio.who.after": "La partie d'après",
  "studio.who.sungBy": "Chantée par",
  "studio.who.hint":
    "Touche une partie pour l'écouter et choisir qui la chante. Fais glisser les poignées blanches pour déplacer les changements de voix.",
  "studio.who.tooShort": "Chaque partie doit durer au moins {secs} secondes.",

  "studio.song.upload": "Importer",
  "studio.song.library": "Bibliothèque",
  "studio.song.tts": "Écrire un texte",
  "studio.song.generate": "Chanson IA",
  "studio.song.mic": "Enregistrer",
  "studio.song.sources": "D'où vient le titre",
  "studio.song.rights":
    "N'importe que des audios que tu as le droit d'utiliser.",
  "studio.song.search": "Rechercher des titres",
  "studio.song.searchUploads": "Rechercher dans tes imports",
  "studio.song.searchLibrary": "Rechercher dans la bibliothèque de titres",
  "studio.song.popular": "Populaires",
  "studio.song.yourUploads": "Tes imports",
  "studio.song.noMatch": "Aucun titre ne correspond à ta recherche.",
  "studio.song.noUploads": "Tu n'as encore rien importé.",
  "studio.song.picked": "Choisi",
  "studio.source.generate": "Généré par IA",
  "studio.source.upload": "Importé",
  "studio.source.library": "De la bibliothèque",
  "studio.source.mic": "Enregistré",
  "studio.source.tts": "Synthèse vocale",

  "studio.tts.what": "Qu'est-ce qu'elles doivent dire ?",
  "studio.tts.placeholder": "Écris ce qu'elles doivent dire...",
  "studio.tts.baseVoice": "VOIX DE BASE",
  "studio.tts.accent": "ACCENT",
  "studio.tts.delivery": "TON",
  "studio.tts.use": "Utiliser ce texte",
  "studio.tts.empty": "Écris un texte.",
  "studio.tts.tooLong": "Le texte dépasse la limite de {max} caractères.",
  "studio.tts.gender.female": "Féminine",
  "studio.tts.gender.male": "Masculine",
  "studio.tts.accent.US": "Américain",
  "studio.tts.accent.GB": "Britannique",
  "studio.tts.accent.FR": "Français",
  "studio.tts.accent.DE": "Allemand",
  "studio.tts.accent.ES": "Espagnol",
  "studio.tts.accent.IT": "Italien",
  "studio.tts.accent.KR": "Coréen",
  "studio.tts.accent.AU": "Australien",
  "studio.tts.accent.JP": "Japonais",
  "studio.tts.expr.default": "Normal",
  "studio.tts.expr.whispered": "Chuchoté",
  "studio.tts.expr.happy": "Joyeux",
  "studio.tts.expr.sad": "Triste",
  "studio.tts.expr.angry": "En colère",
  "studio.tts.expr.shouting": "Crié",
  "studio.tts.expr.terrified": "Terrifié",

  "studio.ai.style": "CHOISIS UN STYLE OU DÉCRIS-LE",
  "studio.ai.styleLabel": "Style du titre",
  "studio.ai.stylePlaceholder":
    "ex. : pop estivale entraînante, guitare acoustique, refrain accrocheur",
  "studio.ai.lyrics": "Paroles",
  "studio.ai.lyricsPlaceholder":
    "Laisse vide pour que l'IA écrive les paroles, ou :\n\n[Verse 1]\nÉcris tes paroles ici...\n\n[Chorus]\nUtilise les balises [Verse], [Chorus] et [Bridge] pour structurer le titre",
  "studio.ai.ownLyrics":
    "+ Écris tes propres paroles (sinon, l'IA s'en charge)",
  "studio.ai.use": "Utiliser ce titre",
  "studio.ai.noStyle": "Décris le style du titre.",
  "studio.ai.styleTooLong":
    "La description du style doit faire moins de {max} caractères.",
  "studio.ai.lyricsTooLong":
    "Les paroles doivent faire moins de {max} caractères.",
  "studio.ai.genre.pop": "Pop",
  "studio.ai.genre.trap": "Trap",
  "studio.ai.genre.rnb": "R&B",
  "studio.ai.genre.indie": "Indie",
  "studio.ai.genre.kpop": "K-pop",
  "studio.ai.genre.edm": "EDM",
  "studio.ai.genre.lofi": "Lo-fi",
  "studio.ai.genre.country": "Country",
  "studio.seo.title": "Créer une cover | Jammable",
  "studio.seo.description":
    "Choisis une voix, ajoute un audio que tu as le droit d'utiliser et crée une cover IA sur Jammable.",
};

export default studio;
